class LocationsDrawer extends ModalDialog {
  constructor() {
    super();
    this.LocationsDrawerTrigger = document.querySelector('locations-drawer-trigger');
    this.locationsButton = this.querySelectorAll('[data-location-button]');
  }

  connectedCallback() {
    this.addEventHandlers();
  }

  addEventHandlers() {
    this.locationsButton.forEach(locationButton => {
      locationButton.addEventListener('click', this.onClickLocationButton.bind(this));
    });
  }

  hide() {
    super.hide();
  }

  onClickLocationButton() {
    this.hide();

    this.LocationsDrawerTrigger?.hide();
  }
}

customElements.define('locations-drawer', LocationsDrawer);

class LocationsDrawerTrigger extends ModalDialog {
  constructor() {
    super();
    this.showLocationsTrigger = getCookie('showChooseLocation');
    this.confirmButton = this.querySelector('[data-confirm-button]');
    this.closeButton = this.querySelector('[id^="ModalClose-"]');
    this.dialogHolder = this.querySelector('[role="dialog"]');
  }

  connectedCallback() {
    this.addEventHandlers();

    if (this.dataset.openInDesignMode === 'true') {
      return;
    }

    if (this.showLocationsTrigger === null) {
      this.show();
    }
  }

  addEventHandlers() {
    if (this.dataset.openInDesignMode === 'true') {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) {
          this.show();
        }
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        this.hide();
      });
    }

    this.confirmButton?.addEventListener('click', this.onClickConfirmButton.bind(this));

    this.closeButton?.addEventListener('click', this.hide.bind(this))
  }

  hide() {
    bodyScroll.unlock(this.dialogHolder);
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.dialogHolder);
    window.pauseAllMedia();

    setCookie('showChooseLocation', 'false', 365);
  }

  onClickConfirmButton() {
    if (this.confirmButton.dataset.languageIsoCode) {
      setCookie('current-locale', this.confirmButton.dataset.languageIsoCode, 365);
    }

    this.hide();
  }
}

customElements.define('locations-drawer-trigger', LocationsDrawerTrigger);
